// core/action/dashboardActions.js
import { dashboardAPI } from './api';
//import { toast } from 'react-toastify';

export const dashboardActions = {
    getDashboardData: async (params = {}) => {
        try {
            const response = await dashboardAPI.get(params);
            
            if (response.data && response.success) {
                return {
                    success: true,
                    data: response.data
                };
            }
            
            return {
                success: false,
                message: response.message || 'Failed to load dashboard data'
            };
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            return {
                success: false,
                message: error.message || 'Failed to load dashboard data'
            };
        }
    },

    // Get recent transactions
    getRecentTransactions: async (params = {}) => {
        try {
            const response = await dashboardAPI.getRecentTransactions(params);
            if (response.data && response.success) {
                return {
                    success: true,
                    data: response.data
                };
            }
            return {
                success: false,
                message: response.message || 'Failed to load transactions'
            };
        } catch (error) {
            console.error('Error fetching transactions:', error);
            return {
                success: false,
                message: error.message || 'Failed to load transactions'
            };
        }
    },

    // Get top selling products
    getTopSellingProducts: async (params = {}) => {
        try {
            const response = await dashboardAPI.getTopSellingProducts(params);
            if (response.data && response.success) {
                return {
                    success: true,
                    data: response.data
                };
            }
            return {
                success: false,
                message: response.message || 'Failed to load top products'
            };
        } catch (error) {
            console.error('Error fetching top products:', error);
            return {
                success: false,
                message: error.message || 'Failed to load top products'
            };
        }
    },

    // Get low stock products
    getLowStockProducts: async (params = {}) => {
        try {
            const response = await dashboardAPI.getLowStockProducts(params);
            if (response.data && response.success) {
                return {
                    success: true,
                    data: response.data
                };
            }
            return {
                success: false,
                message: response.message || 'Failed to load low stock products'
            };
        } catch (error) {
            console.error('Error fetching low stock products:', error);
            return {
                success: false,
                message: error.message || 'Failed to load low stock products'
            };
        }
    },

    // Get sales statistics
    getSalesStatistics: async (params = {}) => {
        try {
            const response = await dashboardAPI.getSalesStatistics(params);
            if (response.data && response.success) {
                return {
                    success: true,
                    data: response.data
                };
            }
            return {
                success: false,
                message: response.message || 'Failed to load sales statistics'
            };
        } catch (error) {
            console.error('Error fetching sales statistics:', error);
            return {
                success: false,
                message: error.message || 'Failed to load sales statistics'
            };
        }
    },

    // Get customer overview
    getCustomerOverview: async (params = {}) => {
        try {
            const response = await dashboardAPI.getCustomerOverview(params);
            if (response.data && response.success) {
                return {
                    success: true,
                    data: response.data
                };
            }
            return {
                success: false,
                message: response.message || 'Failed to load customer overview'
            };
        } catch (error) {
            console.error('Error fetching customer overview:', error);
            return {
                success: false,
                message: error.message || 'Failed to load customer overview'
            };
        }
    },

    // Get top customers
    getTopCustomers: async (params = {}) => {
        try {
            const response = await dashboardAPI.getTopCustomers(params);
            if (response.data && response.success) {
                return {
                    success: true,
                    data: response.data
                };
            }
            return {
                success: false,
                message: response.message || 'Failed to load top customers'
            };
        } catch (error) {
            console.error('Error fetching top customers:', error);
            return {
                success: false,
                message: error.message || 'Failed to load top customers'
            };
        }
    },

    // Format currency helper
    formatCurrency: (amount, currency = 'USD') => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount || 0);
    },

    // Format compact number (e.g., 1.2K, 3.5M)
    formatCompactNumber: (num) => {
        if (num >= 1000000) {
            return (num / 1000000).toFixed(1) + 'M';
        }
        if (num >= 1000) {
            return (num / 1000).toFixed(1) + 'K';
        }
        return num.toString();
    },

    // Get status badge class
    getStatusBadge: (status) => {
        const classes = {
            'Completed': 'bg-success',
            'Pending': 'bg-warning',
            'Cancelled': 'bg-danger',
            'paid': 'bg-success',
            'unpaid': 'bg-warning',
            'pending': 'bg-warning'
        };
        return classes[status] || 'bg-secondary';
    }
};

export default dashboardActions;